import { HydrateOption } from '@core/enums';
import withRedux from '@helpers/withRedux';
import { withQueryProvider } from '@hoc/withQueryProvider';
import withWidget from '@hoc/withWidget';
import React from 'react';
import ViewHiresListing from './ViewHiresListing';
const ViewHires = (props) => {
    return React.createElement(ViewHiresListing, { ...props });
};
export default withWidget(withRedux(withQueryProvider(ViewHires)), 'ViewHires', {
    hydrate: HydrateOption.InView,
});
